import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';

const SELLING_HEADERS = [
    { label: 'Producto', key: 'product_name' },
    { label: 'Stock', key: 'stock' },
    { label: 'Precio', key: 'old_price' },
    { label: 'Precio nuevo', key: 'price' },
    { label: 'Estado', key: 'status' },
];

const PAGE_SIZE = 20;

export class Upselling extends Component {

    constructor(props) {
        super(props);
        this.handler = this.handler.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.deleteSelling = this.deleteSelling.bind(this);
        this.onOpenProductModal = this.onOpenProductModal.bind(this);
        this.onCloseProductModal = this.onCloseProductModal.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
        this.onChangeNewName = this.onChangeNewName.bind(this);
        this.onChangeNewOldPrice = this.onChangeNewOldPrice.bind(this);
        this.onChangeNewPrice = this.onChangeNewPrice.bind(this);
        this.onChangeNewStatus = this.onChangeNewStatus.bind(this);
        this.handleCreateSelling = this.handleCreateSelling.bind(this);
        this.onOpenFullPreview = this.onOpenFullPreview.bind(this);
        this.onCloseFullPreview = this.onCloseFullPreview.bind(this);
        this.state = {
            results: [],
            temp: [],
            loading: false,
            sort: { key: null, dir: 'asc' },
            page: 1,
            openProductModal: false,
            allProducts: [],
            selectedProduct: null,
            newName: '',
            newOldPrice: '',
            newPrice: '',
            newStatus: 'ACTIVATED',
            creating: false,
            fullPreviewOpen: false,
            fullPreviewLoading: false,
            fullPreviewData: null,
            fullPreviewError: null,
        };
    }

    componentWillMount() {
        this.getDataUser();
    }

    getDataUser() {
        const user = AuthService.getCurrentUser();
        this.setState({ loading: true });
        ApiService.getSelling(user.token).then(
            (res) => {
                if (res && res.status === 'success') {
                    const rows = res.data || [];
                    this.setState({ results: rows, temp: rows, loading: false, page: 1 });
                } else {
                    this.setState({ results: [], temp: [], loading: false });
                }
            },
            (error) => {
                this.setState({ loading: false });
            }
        );
    }

    handler(row) {
        this.props.history.push("/edit-selling/" + row.id);
    }

    deleteSelling(row) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea eliminar ' + (row.product_name || row.name) + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                const user = AuthService.getCurrentUser();
                ApiService.deleteSelling(user.token, row.id).then(
                    (res) => {
                        toast.success("Oferta eliminada!");
                        this.getDataUser();
                    },
                    error => {
                        const resMessage =
                            (error.response && error.response.data && error.response.data.message) ||
                            error.message ||
                            error.toString();
                        toast.error(resMessage);
                    }
                );
            }
        });
    }

    onChangeFilter(e) {
        const val = e.target.value.toLowerCase();

        if (this.state.temp.length !== 0) {
            const columns = Object.keys(this.state.temp[0]);
            const rows = this.state.temp.filter((d) => {
                for (let i = 0; i < columns.length; i++) {
                    const column = columns[i];
                    if (d[column] !== null && d[column] !== undefined && d[column].toString().toLowerCase().indexOf(val) > -1) {
                        return true;
                    }
                }
                return false;
            });
            this.setState({ results: rows, page: 1 });
        }

        e.preventDefault();
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    getDataAllProducts() {
        const user = AuthService.getCurrentUser();
        ApiService.getProductStock(user.token).then(
            (res) => {
                if (res && res.status === 'success') {
                    const rows = (res.data || []).slice().sort((a, b) => {
                        const aHas = (parseFloat(a.stock) || 0) > 0 ? 0 : 1;
                        const bHas = (parseFloat(b.stock) || 0) > 0 ? 0 : 1;
                        if (aHas !== bHas) return aHas - bHas;
                        return String(a.name).localeCompare(String(b.name), 'es', { sensitivity: 'base' });
                    });
                    const products = rows.map(function (row) {
                        const stock = parseFloat(row.stock) || 0;
                        const sizeLabel = row.size && row.size.trim() ? ` (${row.size.trim()})` : '';
                        const priceLabel = row.price ? ` - $${row.price}` : '';
                        const stockLabel = stock > 0 ? ` (${stock} en stock)` : ' (sin stock)';
                        return {
                            value: row.id,
                            label: row.name + sizeLabel + priceLabel + stockLabel,
                            productName: row.name + sizeLabel,
                            productPrice: row.price || '',
                        };
                    });
                    this.setState({ allProducts: products });
                }
            },
            (error) => {
                const resMessage =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
            }
        );
    }

    onOpenProductModal() {
        this.setState({
            openProductModal: true,
            selectedProduct: null,
            newName: '',
            newOldPrice: '',
            newPrice: '',
            newStatus: 'ACTIVATED',
        });
        this.getDataAllProducts();
    }

    onCloseProductModal() {
        this.setState({ openProductModal: false });
    }

    handleProductChange(selectedProduct) {
        this.setState({
            selectedProduct,
            newName: selectedProduct ? selectedProduct.productName : '',
            newOldPrice: selectedProduct ? selectedProduct.productPrice : '',
        });
    }

    onChangeNewName(e) {
        this.setState({ newName: e.target.value });
    }

    onChangeNewOldPrice(e) {
        this.setState({ newOldPrice: e.target.value });
    }

    onChangeNewPrice(e) {
        this.setState({ newPrice: e.target.value });
    }

    onChangeNewStatus(e) {
        this.setState({ newStatus: e.target.value });
    }

    handleCreateSelling() {
        if (!this.state.selectedProduct) {
            toast.error('Selecciona un producto');
            return;
        }
        if (!this.state.newName || !this.state.newOldPrice) {
            toast.error('Nombre y precio son obligatorios');
            return;
        }

        this.setState({ creating: true });

        const user = AuthService.getCurrentUser();
        const data_selling = {
            id_product: this.state.selectedProduct.value,
            name: this.state.newName,
            price: this.state.newPrice,
            old_price: this.state.newOldPrice,
            status: this.state.newStatus,
        };

        ApiService.postSelling(user.token, data_selling).then(
            (res) => {
                this.setState({ creating: false });
                if (res && res.status === 'success') {
                    toast.success('Oferta de up selling creada!');
                    this.onCloseProductModal();
                    this.getDataUser();
                } else {
                    toast.error((res && res.message) || 'No se pudo crear la oferta');
                }
            },
            (error) => {
                this.setState({ creating: false });
                const resMessage =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(resMessage);
            }
        );
    }

    onOpenFullPreview() {
        this.setState({
            fullPreviewOpen: true,
            fullPreviewLoading: true,
            fullPreviewData: null,
            fullPreviewError: null,
        });

        const user = AuthService.getCurrentUser();
        ApiService.getSellingPreviewAll(user.token).then(
            (res) => {
                if (res && res.status === 'success') {
                    this.setState({ fullPreviewData: res.data || [], fullPreviewLoading: false });
                } else {
                    this.setState({
                        fullPreviewLoading: false,
                        fullPreviewError: (res && res.message) || 'No se pudo cargar la vista previa',
                    });
                }
            },
            (error) => {
                const resMessage =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                this.setState({ fullPreviewLoading: false, fullPreviewError: resMessage });
            }
        );
    }

    onCloseFullPreview() {
        this.setState({ fullPreviewOpen: false });
    }

    renderFullPreviewCard(item) {
        const borderColor = item.category_color || '#007bff';
        const textColor = item.category_text_color || '#161616';
        const imageUrl = item.image ? `${process.env.REACT_APP_URL_FILES}images/products/${item.image}` : null;
        const oldPrice = parseFloat(item.old_price) || 0;
        const price = parseFloat(item.price) || 0;

        return (
            <div style={{
                border: `2px solid ${borderColor}`, borderRadius: 10, padding: 14,
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                background: '#000', width: '100%', boxSizing: 'border-box',
            }}>
                {imageUrl ? (
                    <div style={{ width: 50, height: 50, overflow: 'hidden', borderRadius: 8 }}>
                        <img src={imageUrl} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                ) : (
                    <div style={{ width: 50, height: 50, borderRadius: 8, background: '#333' }} />
                )}
                <h5 style={{ color: textColor, textAlign: 'center', margin: '10px 0 6px', fontSize: 13 }}>{item.name}</h5>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
                    {oldPrice > 0 && (
                        <span style={{ textDecoration: 'line-through', color: '#aaa', fontSize: 11, display: 'flex', alignItems: 'center', gap: 3 }}>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`} alt="" style={{ width: 10, height: 10 }} />
                            {oldPrice.toFixed(0)}
                        </span>
                    )}
                    <span style={{ color: '#fff', fontWeight: 700, fontSize: 13, display: 'flex', alignItems: 'center', gap: 3 }}>
                        <img src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`} alt="" style={{ width: 10, height: 10 }} />
                        {price.toFixed(0)}
                    </span>
                </div>
                <button
                    type="button"
                    disabled
                    style={{ backgroundColor: borderColor, border: `2px solid ${borderColor}`, color: textColor, padding: '6px 10px', borderRadius: 4, width: '100%', fontSize: 12, cursor: 'default' }}
                >
                    AGREGAR
                </button>
            </div>
        );
    }

    renderFullPreview() {
        const all = this.state.fullPreviewData || [];
        const items = all.filter((i) => i.willShowToCustomer);

        if (items.length === 0) {
            return <div style={{ color: '#ccc', textAlign: 'center', padding: 20 }}>Ninguna oferta se mostraría hoy al cliente.</div>;
        }

        const groups = [];
        for (let i = 0; i < items.length; i += 2) {
            groups.push(items.slice(i, i + 2));
        }

        return (
            <div>
                {groups.map((group, idx) => (
                    <div key={idx} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                        {group.map((item) => (
                            <div key={item.id_product}>{this.renderFullPreviewCard(item)}</div>
                        ))}
                    </div>
                ))}
            </div>
        );
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0', gap: 8,
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-left' />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-right' />
                    </button>
                </div>
            </div>
        );
    }

    renderResults() {
        const { results, sort, page, loading } = this.state;
        if (loading) return <div style={{ padding: 16, color: '#888' }}>Cargando...</div>;
        if (!results || results.length === 0) return <div style={{ padding: 16, color: '#888' }}>No hay datos.</div>;

        const sorted = sortRows(results, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

        return (
            <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                {SELLING_HEADERS.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} />
                                ))}
                                <th style={{ padding: '10px 12px', color: '#888', fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap' }}>
                                    Acción
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item) => (
                                <tr
                                    key={item.id}
                                    style={{ borderBottom: '1px solid #f4f4f4' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f8fbff')}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                >
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 500 }}>
                                        {item.product_name || `#${item.id_product}`}
                                        {!item.willShowToCustomer && (
                                            <i className="fa fa-exclamation-triangle" title={item.reason} style={{ color: '#e9b949', marginLeft: 6, fontSize: 12 }} />
                                        )}
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                        <span style={{
                                            background: item.stock > 0 ? '#d4edda' : '#f8d7da',
                                            color: item.stock > 0 ? '#155724' : '#721c24',
                                            borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600,
                                        }}>
                                            {item.stock}
                                        </span>
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666' }}>
                                        {item.old_price}
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700 }}>
                                        {item.price}
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                        <span style={{
                                            background: item.status === 'ACTIVATED' ? '#d4edda' : '#f8d7da',
                                            color: item.status === 'ACTIVATED' ? '#155724' : '#721c24',
                                            borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600,
                                        }}>
                                            {item.status}
                                        </span>
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                                        <i
                                            className="fa fa-pencil"
                                            title="Editar"
                                            onClick={() => this.handler(item)}
                                            style={{ cursor: 'pointer', fontSize: 16, padding: 6, color: 'rgb(40, 167, 69)' }}
                                        />
                                        <i
                                            className="fa fa-trash"
                                            title="Eliminar"
                                            onClick={() => this.deleteSelling(item)}
                                            style={{ cursor: 'pointer', fontSize: 16, padding: 6, color: '#e4566e' }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(sorted.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="List Up Selling" parent="Selling" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card" style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                                <div className="card-header" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                                    <h5 style={{ margin: 0 }}>Ofertas de Up Selling</h5>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <input
                                            placeholder="Buscar..."
                                            name="filter"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onInput={this.onChangeFilter}
                                            style={{ flex: '1 1 180px', minWidth: 140, maxWidth: 260, height: 32, boxSizing: 'border-box', padding: '4px 10px' }}
                                        />
                                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.onOpenFullPreview}>
                                            Vista previa
                                        </button>
                                        <button type="button" className="btn btn-secondary btn-sm" onClick={this.onOpenProductModal}>
                                            Nueva oferta
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body" style={{ padding: 0 }}>
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal open={this.state.openProductModal} onClose={this.onCloseProductModal} center>
                    <div className="modal-header">
                        <h5 className="modal-title">Nueva oferta de Up Selling</h5>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label>Producto</label>
                            <Select
                                value={this.state.selectedProduct}
                                onChange={this.handleProductChange}
                                options={this.state.allProducts}
                                placeholder="Busca un producto..."
                                isClearable={true}
                            />
                        </div>
                        <div className="form-group">
                            <label><span>*</span> Nombre</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.newName}
                                onChange={this.onChangeNewName}
                            />
                        </div>
                        <div className="form-group">
                            <label><span>*</span> Precio</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.newOldPrice}
                                onChange={this.onChangeNewOldPrice}
                            />
                        </div>
                        <div className="form-group">
                            <label>Precio nuevo</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.newPrice}
                                onChange={this.onChangeNewPrice}
                            />
                        </div>
                        <div className="form-group">
                            <label><span>*</span> Estado</label>
                            <div className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                                <label className="d-block" style={{ marginRight: '1rem' }}>
                                    <input
                                        name="newStatus"
                                        type="radio"
                                        value="ACTIVATED"
                                        checked={this.state.newStatus === 'ACTIVATED'}
                                        onChange={this.onChangeNewStatus}
                                    />
                                    {' '}ACTIVADO
                                </label>
                                <label className="d-block">
                                    <input
                                        name="newStatus"
                                        type="radio"
                                        value="DESACTIVATED"
                                        checked={this.state.newStatus === 'DESACTIVATED'}
                                        onChange={this.onChangeNewStatus}
                                    />
                                    {' '}DESACTIVADO
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={this.onCloseProductModal}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={this.handleCreateSelling} disabled={this.state.creating}>
                            {this.state.creating ? 'Guardando...' : 'Crear oferta'}
                        </button>
                    </div>
                </Modal>

                <Modal open={this.state.fullPreviewOpen} onClose={this.onCloseFullPreview} center>
                    <div style={{ width: '100%', maxWidth: 340, margin: '0 auto', background: '#161616', borderRadius: 12, padding: '20px 14px', fontFamily: "'Work Sans', sans-serif" }}>
                        <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, textAlign: 'center', marginBottom: 16 }}>
                            ¿Un último antojo a precio fumón?
                        </div>
                        {this.state.fullPreviewLoading && (
                            <div style={{ padding: 24, textAlign: 'center', color: '#888' }}>Cargando vista previa...</div>
                        )}
                        {!this.state.fullPreviewLoading && this.state.fullPreviewError && (
                            <div style={{ padding: 24, textAlign: 'center', color: '#e57373' }}>{this.state.fullPreviewError}</div>
                        )}
                        {!this.state.fullPreviewLoading && !this.state.fullPreviewError && this.renderFullPreview()}
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export default Upselling;
